"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migration_75_16_0 = void 0;
/**
 * Migrate to 75.16.0
 *
 * Adds SplitPositionX to configuration
 */
const migration_75_16_0 = (json) => {
    if (json.Espool && !json.SplitPositionX) {
        json.SplitPositionX = 0;
        return json;
    }
    return json;
};
exports.migration_75_16_0 = migration_75_16_0;
//# sourceMappingURL=migration_75_16_0.js.map